import { data as routerData, type LoaderFunctionArgs, redirect, type RouterContextProvider } from 'react-router'

import {
  clientContext,
  dashboardContext,
} from 'apps/employer_dashboard/router_contexts'
import EmployerHomePage from 'components/employers/home/HomePage'
import { getRequestIdFromError } from 'utils/errors'
import {
  getEmployersEmployerInvoicesLastMonthCosts,
  getEmployersEnrollmentsCounts,
  getEmployersImportantDates,
  getEmployersTodos,
  getGetEmployersEmployerInvoicesLastMonthCostsQueryKey,
  getGetEmployersEnrollmentsCountsQueryKey,
  getGetEmployersImportantDatesQueryKey,
  getGetEmployersTodosQueryKey,
} from 'utils/web_api'
import { type GetEmployersImportantDatesParams, type GetEmployersTodosParams } from 'utils/web_api.schemas'

export async function loader ({ context }: LoaderFunctionArgs<RouterContextProvider>) {
  const { features } = context.get(dashboardContext) || {}
  const queryClient = context.get(clientContext)

  if (!features?.home_page_enabled) {
    throw redirect('/employers/dashboard/employees')
  }

  try {
    const todoParams: GetEmployersTodosParams = {
      'categories[]': ['onboarding', 'general'],
    }
    const todosQuery = queryClient?.ensureQueryData({
      queryKey: getGetEmployersTodosQueryKey(todoParams),
      queryFn: () => getEmployersTodos(todoParams),
    })

    const enrollmentQuery = queryClient?.ensureQueryData({
      queryKey: getGetEmployersEnrollmentsCountsQueryKey(),
      queryFn: () => getEmployersEnrollmentsCounts(),
    })

    const importantDatesParams: GetEmployersImportantDatesParams = {
      num_future_days: 30,
    }
    const importantDatesQuery = queryClient?.ensureQueryData({
      queryKey: getGetEmployersImportantDatesQueryKey(importantDatesParams),
      queryFn: () => getEmployersImportantDates(importantDatesParams),
    })

    const lastMonthCostsQuery = queryClient?.ensureQueryData({
      queryKey: getGetEmployersEmployerInvoicesLastMonthCostsQueryKey(),
      queryFn: () => getEmployersEmployerInvoicesLastMonthCosts(),
    })

    await Promise.all([todosQuery, enrollmentQuery, importantDatesQuery, lastMonthCostsQuery])
  } catch (error) {
    throw routerData({
      heading: 'We could not load the home page',
      message: 'Something unexpected happened. We have been notified and are looking into it.',
      requestId: getRequestIdFromError(error),
    })
  }
}

export function HomePage () {
  // TODO: Move the `<EmployerHomePage />` component into the
  // `apps/employer_dashboard` directory after the migration is complete.
  return <EmployerHomePage />
}
